import { cn } from "@/lib/cn";

export interface SkeletonProps {
  className?: string;
}

/**
 * Loading placeholder. The shimmer respects prefers-reduced-motion (it falls back to a static block).
 * Use to fill the shape of the content that's loading, not a generic spinner — keeps layout stable.
 */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-(--radius-sm) bg-(--surface-sunken) ring-1 ring-inset ring-(--border-hairline) motion-reduce:animate-none",
        className,
      )}
      aria-hidden
    />
  );
}

/** Convenience: N stacked skeleton rows for table/list loading states. */
export function SkeletonRows({ rows = 5, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn("flex flex-col gap-2", className)} role="status" aria-busy="true">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-9 w-full" />
      ))}
    </div>
  );
}
